<template>
  <div>
    <DataTable
      :value="tags"
      :paginator="true"
      dataKey="contactId"
      class="p-datatable-striped p-datatable-sm p-datatable-gridlines p-datatable-customers"
      :rows="50"
      :rowHover="true"
      :selection.sync="selectedTags"
      :filters="filters"
      :loading="loading"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      :rowsPerPageOptions="[25, 50, 100]"
      currentPageReportTemplate="{first} to {last} of {totalRecords} activityResults"
    >
      <template #empty> No activityResults found. </template>
      <template #loading> Loading activityResults data. Please wait. </template>
      <Column selectionMode="multiple" headerStyle="width: 3em;"></Column>
      <Column
        field="id"
        header="id"
        headerStyle="width: 3em"
        :sortable="true"
      >
        <template #body="slotProps">
          <div>
              {{ slotProps.data.id }}
          </div>
        </template>
      </Column>
      <Column
        field="tag"
        header="Code"
        headerStyle="width: 8em"
        :sortable="true"
      >
        <template #body="slotProps">
          <div>
              {{ slotProps.data.tag }}
          </div>
        </template>
      </Column>
      <Column
        field="type"
        header="Code"
        headerStyle="width: 8em"
        :sortable="true"
      >
        <template #body="slotProps">
          <div>
              {{ slotProps.data.type }}
          </div>
        </template>
      </Column>
      <Column
        field="active"
        header="Is Active"
        headerStyle="width: 3em"
        :sortable="true"
      >
        <template #body="slotProps">
          <span v-if="slotProps.data.active">YES</span>
          <span v-else>NO</span>
        </template>
      </Column>
      <!-- <Column
        field="colour"
        header="Colour"
        headerStyle="width: 8em"
        :sortable="true"
      >
        <template #body="slotProps">
          <span 
            :class="'ignore pointer badge ' + getStyle(slotProps.data.colourCode)" 
          >
            {{ slotProps.data.colourCode }}
          </span>
        </template>
      </Column> -->
      <Column headerStyle="width: 7em;">
        <template #body="slotProps">
          <div
            :style="{position: 'relative'}"
          >
            <SplitButton 
              label="Edit" 
              icon="pi pi-pencil" 
              class="p-button-success p-mb-2"
              @click="editTag(slotProps.data)" 
              :model="getButtons(slotProps.data)"
            >
            </SplitButton>
          </div>
          <!-- <Button
            icon="pi pi-pencil"
            class="p-button-rounded p-button-success p-mr-2"
            @click="editTag(slotProps.data)"
          />
          <Button
            icon="pi pi-trash"
            class="p-button-rounded p-button-warning"
            @click="deleteTag(slotProps.data)"
          /> -->
        </template>
      </Column>
    </DataTable>
  </div>
</template>

<script>
import PermissionMixin from '../PermissionMixin.vue'
export default {
  mixins: [PermissionMixin],
  props: [
    'tags',
    'loading'
  ],
  data: () => ({
    selectedTags: null,
    filters: {
      global: ''
    }
  }),
  created() {
    this.filters.global = this.$route.query.search
  },
  methods: {
    getButtons(data) { 
      this.checkPermissions()
      let buttons = []
      if (this.deleteSettings) {
        buttons.push(
          {
            label: 'Delete',
            icon: 'pi pi-trash',
            command: () => {
              this.deleteTag(data)
            }
          }
        )
      }
      return buttons
    },
    getStyle(data) {
      
    },
    deleteTag(tag) {
      this.$emit('delete-tag', tag)
    },
    editTag(tag) {
      this.$emit('edit-tag', tag)
    }
  }
}
</script>

<style scoped>

</style>